export default __webpack_public_path__ + "38117ee80dfcd8c0fc8e7c12a8d235aa.png";